import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router'
import Link from '@mui/material/Link'
import List from '@mui/material/List'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'
import ArticleIcon from '@mui/icons-material/Article'
import DashboardIcon from '@mui/icons-material/Dashboard'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import FontDownloadIcon from '@mui/icons-material/FontDownload'
import NewspaperIcon from '@mui/icons-material/Newspaper'
import PodcastsIcon from '@mui/icons-material/Podcasts'
import QuizIcon from '@mui/icons-material/Quiz'
import SchoolIcon from '@mui/icons-material/School'
//import ImageIcon from '@mui/icons-material/Image'
//import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
//import MicIcon from '@mui/icons-material/Mic'
import { isDev } from '../../config/config'

const drawerWidth = 240

const StyledList = styled(List)({
  backgroundColor: '#343a40',
  height: '100%',
})

function NavDrawer({ open, handleDrawerClose }) {
  let menuItems = [
    {
      link: '/',
      name: 'Dashboard',
      onClick: handleDrawerClose,
      icon: <DashboardIcon sx={{ color: '#fff' }} />,
    },
    {
      link: '/academy',
      name: 'Academy',
      onClick: handleDrawerClose,
      icon: <SchoolIcon sx={{ color: '#fff' }} />,
    },
    {
      link: '/glossary',
      name: 'Glossary',
      onClick: handleDrawerClose,
      icon: <FontDownloadIcon sx={{ color: '#fff' }} />,
    },
    {
      link: '/interview',
      name: 'Interviews',
      onClick: handleDrawerClose,
      icon: <ArticleIcon sx={{ color: '#fff' }} />,
    },
    {
      link: '/cert',
      name: 'Certification',
      onClick: handleDrawerClose,
      icon: <EmojiEventsIcon sx={{ color: '#fff' }} />,
    },
  ]

  const menuItemsDev = [
    {
      link: '/newsletter',
      name: 'Newsletter',
      onClick: handleDrawerClose,
      icon: <NewspaperIcon sx={{ color: '#fff' }} />,
    },
    {
      link: '/podcast',
      name: 'Podcast',
      onClick: handleDrawerClose,
      icon: <PodcastsIcon sx={{ color: '#fff' }} />,
    },
    {
      link: '/story',
      name: 'Story',
      onClick: handleDrawerClose,
      icon: <ArticleIcon sx={{ color: '#fff' }} />,
    },
    
     {
      link: '/Metadata',
      name: 'Metadata',
      onClick: handleDrawerClose,
      icon: <ArticleIcon sx={{ color: '#fff' }} />,
    },
  ]

  if (isDev) menuItems = [...menuItems, ...menuItemsDev]

  return (
    <Box sx={{ position: 'relative', display: 'flex', overflow: 'hidden' }}>
      {open ? (
        <Drawer variant="temporary" open={open} ModalProps={{ keepMounted: true }}>
          <Toolbar sx={{ width: drawerWidth }}>
            <ListItem disableGutters>
              <ListItemIcon sx={{ marginRight: 0.5 }}>
                <IconButton onClick={handleDrawerClose} aria-label="Close Menu" size="large">
                  <CloseIcon color="primary" />
                </IconButton>
              </ListItemIcon>
            </ListItem>
          </Toolbar>
          <Divider />
          <StyledList>
            {menuItems.map(element => {
              return (
                <Link component={RouterLink} key={element.name} to={element.link} onClick={handleDrawerClose} underline="none">
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemIcon>{element.icon}</ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="subtitle1" sx={{ color: '#fff' }}>
                            {element.name}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                </Link>
              )
            })}
          </StyledList>
          <Divider />
        </Drawer>
      ) : null}
    </Box>
  )
}

NavDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
}

export default NavDrawer
